import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setPage } from 'redux/actions';
import { withAuth } from 'components/shared/Auth';
import './ChangePasswordPage.css';

class ChangePasswordPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      resetFailed: false,
      resetSucceeded: false,
      resetPending: false
    };
  }

  componentDidMount() {
    this.props.dispatch(setPage('ChangePasswordPage'));
  }

  componentDidUpdate() {}

  render() {
    if (!this.props.user) {
      return null;
    }

    return (
      <div className="ChangePasswordPage pageStyle">
        <div className="ChangePasswordPage_Title">Change Password</div>

        {!this.state.resetFailed && !this.state.resetSucceeded ? (
          <div className="ChangePasswordPage_Confirm">
            <div className="ChangePasswordPage_Confirm_Header">
              Send password change email to {this.props.user.name}?
            </div>
            <div className="ChangePasswordPage_Confirm_Body">
              <button
                className="Global_RoundedButton ChangePasswordPage_Confirm_Button"
                onClick={() => {
                  this.setState({ resetFailed: false, resetSucceeded: false, resetPending: true });
                  this.props.auth.resetPassword(this.props.user.name, (err) => {
                    if (err) {
                      this.setState({ resetFailed: true, resetPending: false });
                    } else {
                      this.setState({ resetSucceeded: true, resetPending: false });
                    }
                  });
                }}
              >
                {this.state.resetPending ? <FontAwesomeIcon className="LoadingIcon" icon="spinner" pulse /> : 'Confirm'}
              </button>
            </div>
          </div>
        ) : this.state.resetSucceeded ? (
          <div className="ChangePasswordPage_Confirm">
            <div className="ChangePasswordPage_Confirm_Success">
              Password change request sent. You should receive an email containing a link to change your password.{' '}
            </div>
          </div>
        ) : (
          <div className="ChangePasswordPage_Confirm">
            <div className="ChangePasswordPage_Confirm_Failed">
              Unable to send password reset email to {this.props.user.name}. <br />
              <br />
              If this problem persists, please contact
              <a className="Global_Link" href="mailto:support@pivotalcommware.com">
                support@pivotalcommware.com
              </a>{' '}
              for assistance.
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withAuth(connect((store) => {
  return {
    user: store.data.user
  };
})(ChangePasswordPage));
